module.exports = __webpack_public_path__ + "img/ls-h-branco.f59d269c.svg";